// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".WJNoMrKapN_u9c6uKZF2N {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  font-size: 18px;\n}\n", "",{"version":3,"sources":["PostFooter.css"],"names":[],"mappings":"AAAA;EACE,oBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,sCAAA;MAAA,sBAAA;UAAA,8BAAA;EACA,eAAA;AAOF","file":"PostFooter.css","sourcesContent":[".linkContainer {\n  display: flex;\n  justify-content: space-between;\n  font-size: 18px;\n}\n"]}]);
// Exports
exports.locals = {
	"linkContainer": "WJNoMrKapN_u9c6uKZF2N"
};
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader/dist/cjs.js??ref--1-1!../node_modules/postcss-loader??ref--1-2!./components/PostFooter/PostFooter.css
// module id = 523
// module chunks = 37